module.exports = "h2 {\r\n    text-align: center;\r\n}\r\n\r\nbutton {\r\n    margin: auto;\r\n    margin-top: 10px;\r\n}\r\n"